'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'classnames';
import Link from 'next/link';
import PropTypes from 'prop-types';

import { BLOCKS } from '@contentful/rich-text-types';

import BlockTwoColumnImage from 'components/blocks/BlockTwoColumnImage/BlockTwoColumnImage';
import Accordion, { Child as AccordionChild } from 'components/ui/Accordion';
import ButtonCTA from 'components/ui/ButtonCTA';
import Img from 'components/ui/Img';
import RichText from 'components/ui/RichText';
import SvgIcon from 'components/ui/SvgIcon';
import Text from 'components/ui/Text';

import { getColor } from 'utils';

import Handling from './Handling';
import Ingredients from './Ingredients';
import Nutrition from './Nutrition';
import ProductList from './ProductList';

import styles from './Product.module.scss';

const richTextOverrides = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => (
            <Text className={styles.productDescription} baseTheme="bodyMedium">
                {children}
            </Text>
        ),
    },
};

const contactBlock = {
    image: {
        title: 'Foodservice - Contact Us',
        description:
            "For when I gaze into your eyes\nOf deepest blue I see,\nYou're everything I've longed for most\nYou set my spirit free.",
        url: '//images.ctfassets.net/j8tkpy1gjhi5/5cyehePw9siXny1JxTxy1/cbee180b07ad497a1cd5a71752bea14f/contact-us-people.jpg',
        width: 1248,
        height: 1248,
        fileName: 'contact-us-people.jpg',
        contentType: 'image/jpeg',
    },
    ctas: [
        {
            text: 'Contact Us',
            style: 'filled-blue-ocean',
            link: {
                as: 'foodservice/contact',
                id: '12iS7dY2JVRrfg1FnhVwwI',
                __typename: 'ManualLink',
            },
            theme: 'filledBlue',
            sys: {
                id: '6xtPtQvAdPuGdwCQv1tYas',
            },
            __typename: 'ctaButton',
        },
    ],
    hasArrowIcon: true,
    lastBlock: true,
    leftImage: true,
    richHeadline: {
        json: {
            data: {},
            content: [
                {
                    data: {},
                    content: [
                        {
                            data: {},
                            marks: [],
                            value: 'We’d love',
                            nodeType: 'text',
                        },
                    ],
                    nodeType: 'heading-3',
                },
                {
                    data: {},
                    content: [
                        {
                            data: {},
                            marks: [],
                            value: 'to hear',
                            nodeType: 'text',
                        },
                    ],
                    nodeType: 'heading-3',
                },
                {
                    data: {},
                    content: [
                        {
                            data: {},
                            marks: [],
                            value: 'from you!',
                            nodeType: 'text',
                        },
                    ],
                    nodeType: 'heading-3',
                },
                {
                    data: {},
                    content: [
                        {
                            data: {},
                            marks: [],
                            value: '',
                            nodeType: 'text',
                        },
                    ],
                    nodeType: 'paragraph',
                },
            ],
            nodeType: 'document',
        },
    },
    richText: {
        json: {
            data: {},
            content: [
                {
                    data: {},
                    content: [
                        {
                            data: {},
                            marks: [],
                            value: 'Are you a foodservice provider who can’t find what you’re looking for? Get in touch.',
                            nodeType: 'text',
                        },
                    ],
                    nodeType: 'paragraph',
                },
            ],
            nodeType: 'document',
        },
    },
};

const Product = ({
    displayName,
    slug,
    category,
    productGroup,
    color,
    image,
    nutritionInfo,
    allergens,
    sizes,
    ingredients,
    topBlocks,
    bottomBlocks,
    productDescription,
    storageAndHandling,
    sharpnessStoryBlock,
    productList,
    award,
    productGuide,
    eyebrow,
}) => {
    const { width, height } = image || {
        width: 0,
        height: 0,
    };

    const isTopSeller = award === 'top seller';

    return (
        <>
            <div className={cx(styles.productPage)}>
                <div
                    style={{
                        '--product-color': getColor(color),
                    }}
                    className={styles.header}
                >
                    {isTopSeller && (
                        <img
                            className={styles.topSeller}
                            src="/images/icons/top-seller.svg"
                            alt=""
                        />
                    )}
                    <div className={styles.headerInner}>
                        {image?.url && (
                            <figure className={styles.productImageWrapper}>
                                <div
                                    style={{
                                        paddingTop: `${
                                            (height / width) * 100
                                        }%`,
                                    }}
                                    className={styles.aspectBox}
                                >
                                    <Img
                                        className={cx(styles.productImage)}
                                        src={image.url}
                                        width={image?.width}
                                        height={image?.height}
                                        fallbackImageWidth={650}
                                        customSources={[
                                            {
                                                breakpoint: 1920,
                                                src: image.url,
                                                imageWidth: 650 * 1.5,
                                            },
                                            {
                                                breakpoint: 1440,
                                                src: image.url,
                                                imageWidth: 650 * 1.5,
                                            },
                                            {
                                                breakpoint: 1024,
                                                src: image.url,
                                                imageWidth: 650 * 1.5,
                                            },
                                            {
                                                breakpoint: 768,
                                                src: image.url,
                                                imageWidth: 650 * 1.5,
                                            },
                                            {
                                                src: image.url,
                                                imageWidth: 300 * 1.5,
                                            },
                                        ]}
                                    />
                                </div>
                            </figure>
                        )}
                    </div>
                    <div className={styles.headerContent}>
                        {eyebrow && (
                            <Text
                                className={styles.eyebrow}
                                as="h3"
                                baseTheme="labelSmall"
                                themes={{ large: 'labelLarge' }}
                            >
                                {eyebrow}
                            </Text>
                        )}
                        <div className={styles.title}>
                            <Text.Theme
                                as="h1"
                                config={{
                                    default: {
                                        baseTheme: 'displaySmall',
                                        themes: {
                                            medium: 'displayMedium',
                                            xLarge: 'displayLarge',
                                            xxxLarge: 'displayXLarge',
                                        },
                                    },
                                }}
                            >
                                {displayName}
                            </Text.Theme>
                        </div>
                        {sizes && (
                            <div className={styles.weights}>
                                <Text
                                    baseTheme="labelSmall"
                                    themes={{ medium: 'labelLarge' }}
                                >
                                    {sizes.join(' / ')}
                                </Text>
                            </div>
                        )}
                        {productDescription && (
                            <div className={styles.productDescriptionWrapper}>
                                <RichText
                                    richText={productDescription}
                                    overrides={richTextOverrides}
                                />
                            </div>
                        )}
                        <div className={styles.ctaButtons}>
                            <ButtonCTA
                                className={styles.ctaButton}
                                text="Contact Us"
                                style="filled-blue-ocean"
                                link={{ slug: 'foodservice/contact' }}
                            />

                            {productGuide?.url && (
                                <ButtonCTA
                                    className={styles.ctaButton}
                                    text="Product Guide"
                                    style="outlined-blue-blue"
                                    iconType="download"
                                    link={{ url: productGuide.url }}
                                />
                            )}
                        </div>
                    </div>
                </div>
                {productGroup?.products?.items && (
                    <div className={styles.productVariantsContainer}>
                        <ul className={styles.productVariants}>
                            {productGroup.products.items.map((product, i) => {
                                return (
                                    <li key={i}>
                                        <Link
                                            as={`/foodservice/products/${category.slug}/${product.slug}`}
                                            href={`/foodservice/products/[category]/[product]`}
                                            scroll={false}
                                            className={cx(
                                                styles.productVariant,
                                                {
                                                    [styles[
                                                        'productVariant--selected'
                                                    ]]: slug == product.slug,
                                                }
                                            )}
                                        >
                                            <Img
                                                src={
                                                    product.groupThumbnail
                                                        ?.url ||
                                                    product.image?.url
                                                }
                                                width={
                                                    product.groupThumbnail
                                                        ?.width ||
                                                    product.image?.width
                                                }
                                                height={
                                                    product.groupThumbnail
                                                        ?.height ||
                                                    product.image?.height
                                                }
                                                fallbackImageWidth={150}
                                                loading="eager"
                                                alt={displayName}
                                            />
                                            <Text
                                                baseTheme="labelSmall"
                                                themes={{
                                                    medium: 'labelLarge',
                                                }}
                                                className={
                                                    styles[
                                                        'productVariant__title'
                                                    ]
                                                }
                                            >
                                                {product.groupLabel}
                                            </Text>
                                            {slug == product.slug && (
                                                <div
                                                    className={
                                                        styles.productVariantIconChecked
                                                    }
                                                    aria-hidden="true"
                                                    role="presentation"
                                                >
                                                    <SvgIcon type="roundCheckAlt" />
                                                </div>
                                            )}
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}
                <div className={styles.blocks}>{topBlocks}</div>
                {sharpnessStoryBlock}
                {productList && (
                    <div className={styles.content}>
                        <div className={styles.contentInner}>
                            <div className={styles.filledLabel}>
                                <Text
                                    baseTheme="labelMedium"
                                    themes={{ large: 'labelLarge' }}
                                >
                                    Product List
                                </Text>
                            </div>
                            <ProductList data={productList} />
                        </div>
                    </div>
                )}
                <div className={styles.content}>
                    <div className={styles.contentInner}>
                        <div className={styles.filledLabel}>
                            <Text
                                baseTheme="labelMedium"
                                themes={{ large: 'labelLarge' }}
                            >
                                Product Information
                            </Text>
                        </div>
                        <Accordion>
                            <AccordionChild label={'Nutrition & Allergens'}>
                                <Nutrition
                                    nutritionInfo={nutritionInfo}
                                    allergens={allergens}
                                />
                            </AccordionChild>
                            <AccordionChild label={'Ingredients'}>
                                <Ingredients ingredients={ingredients} />
                            </AccordionChild>

                            {storageAndHandling && (
                                <AccordionChild label="Handling & Storage">
                                    <Handling handling={storageAndHandling} />
                                </AccordionChild>
                            )}
                        </Accordion>
                    </div>
                </div>
                <div className={styles.blocks}>
                    {bottomBlocks}
                    <BlockTwoColumnImage {...contactBlock} />
                </div>
            </div>
        </>
    );
};

Product.propTypes = {
    displayName: PropTypes.string.isRequired,
    productDescription: PropTypes.object,
    pageTitle: PropTypes.string.isRequired,
    pageDescription: PropTypes.string,
    category: PropTypes.object.isRequired,
    slug: PropTypes.string.isRequired,
    productGroup: PropTypes.object,
    color: PropTypes.string.isRequired,
    award: PropTypes.oneOf(['none', 'top seller']),
    image: PropTypes.object,
    nutritionInfo: PropTypes.array.isRequired,
    allergens: PropTypes.string,
    sizes: PropTypes.array,
    groupThumbnail: PropTypes.object,
    eyebrow: PropTypes.string,
    ingredients: PropTypes.array,
    sys: PropTypes.object.isRequired,
    tillamapsUrl: PropTypes.string,
    shopProduct: PropTypes.object,
    theme: PropTypes.string,
    storageAndHandling: PropTypes.object,
    sharpnessStoryBlock: PropTypes.object,
    productList: PropTypes.array,
    topBlocks: PropTypes.array,
    bottomBlocks: PropTypes.array,
    productGuide: PropTypes.object,
};

export default Product;
